import React,{useCallback, useMemo} from 'react';
import { Grid } from '@mui/material';
import Epic from '../components/epic/epic';

const MilestoneSection = ({
  showEpic,
  cardId,
  setShowEpic,
  data,
  currentUserId,
  checkBoardOwnerOrAdmin,
  updateCardmutate,
  boardPermission
}) => {

  const hasEditPermission = useMemo(() => 
    checkBoardOwnerOrAdmin ||
    data?.reporter == currentUserId() ||
    (boardPermission?.can_edit_task && data?.assigned_to_user_id == currentUserId() ),
    [checkBoardOwnerOrAdmin, data?.assigned_to_user_id, data?.reporter, currentUserId, boardPermission?.can_edit_task]
  );

  const handleEpicBlur = useCallback((epic_id) => {
    setShowEpic(false);
    if (data?.epic?.epic_id !== epic_id) {
      updateCardmutate({
        card_id: cardId,
        data: {
          epic_id: epic_id,
        },
      });
    }
  }, [data?.epic?.epic_id, cardId, setShowEpic, updateCardmutate]);

  const handleShowEpic = useCallback(() => {
    if (hasEditPermission) {
      setShowEpic(true);
    }
  }, [hasEditPermission, setShowEpic]);


  return (
    <div className="box">
      <Grid item className="allocated-hours">
        <p>Milestone</p>
        <div className="taskdetail-sidebar-right-col">
          {showEpic ? (
            <Epic
              handleEpicBlur={handleEpicBlur}
              cardId={cardId}
              showEpic={showEpic}
              setShowEpic={setShowEpic}
              boardId={data?.board_id}
            />
          ) : (
            <div className="due-date" onClick={handleShowEpic}>
              <div className="due-date-input">
                {data?.epic?.epic_name ? (
                  data?.epic?.epic_name
                ) : (
                  <p className="due-date-input-none">None</p>
                )}
              </div>
            </div>
          )}
        </div>
      </Grid>
    </div>
  );
};

const areEqual = (prevProps, nextProps) => {
  return prevProps.data?.epic?.epic_name === nextProps.data?.epic?.epic_name
  && prevProps.data?.epic?.epic_id === nextProps.data?.epic?.epic_id
  && prevProps.cardId === nextProps.cardId
  && prevProps.data.assigned_to_user_id === nextProps.data.assigned_to_user_id
  && prevProps.data.reporter === nextProps.data.reporter
  && prevProps.hasEditPermission === nextProps.hasEditPermission
  && prevProps.updateCardmutate === nextProps.updateCardmutate
  && prevProps.setShowEpic === nextProps.setShowEpic
  && prevProps.boardId === nextProps.boardId
  && prevProps.checkBoardOwnerOrAdmin === nextProps.checkBoardOwnerOrAdmin
  && prevProps.currentUserId === nextProps.currentUserId
  && prevProps.showEpic === nextProps.showEpic
};

export default React.memo(MilestoneSection, areEqual);